export default __webpack_public_path__ + "static/media/Step-6-safari.9c98877e.mov";